import { put } from "redux-saga/effects";
import * as actionsIndex from "../actions/index";

export function* initSetSessionActiveSaga(action) {
  try {
    yield put(actionsIndex.setSessionActive(action.session));
  } catch (error) {}
}
